export default function()
{
    const self = this;

    /**
     * Whether the Geolocation API is available in the browser
     * @type {Boolean}
     */
    self.apiAvailable = ('geolocation' in navigator);

    /**
     * Prevents multiple calls to get the location
     * @type {Boolean}
     */
    self.firstGeolocationCall = true;

    /**
     * Prevents duplicate getting of location
     * @type {Boolean}
     */
    self.locationIsSet = false;

    /**
     * The current location of the visitor, as a {latitude, longitude} object
     * @type {Object|null}
     */
    self.currentLocation = null;

    /**
     * If the location is loading or not
     * @type {boolean}
     */
    self.loading = false;

    /**
     * Get the permission status of the Geolocation API
     * @return {Promise}
     * @resolve {String|null}
     */
    self.getPermissionState = () => {
        const defer = $.Deferred();

        // Resolve with null if the API is not available
        if (! self.apiAvailable) {
            defer.resolve(null);
        } else {
            // Resolve with the permission status
            navigator.permissions.query({ name: 'geolocation' })
                .then(PermissionStatus => {
                    defer.resolve(PermissionStatus.state);
                });
        }

        return defer;
    };

    /**
     * Get the location of the visitor, using the Geolocation API
     * @return {Promise}
     * @resolve {Object|null}
     */
    self.getCurrentLocation = (force = false) => {
        const defer = $.Deferred();

        if(self.loadingLocation()) {
           return defer;
        }

        if(false === force && this.getLocationFromSession()) {
            self.currentLocation = this.getLocationFromSession();
            self.locationIsSet = true;
            self.loading = false;
            defer.resolve(this.getLocationFromSession());
            return defer;
        }

        // Resolve immediately if the location is set
        if (self.locationIsSet) {
            self.setLocationInSession();
            defer.resolve(self.currentLocation);
            return defer;
        }

        // Resolve with null if the Geolocation API is not available
        if (! self.apiAvailable) {
            self.currentLocation = null;
            self.locationIsSet = true;
            self.loading = false;
            self.setLocationInSession();
            defer.resolve(self.currentLocation);
            return defer;
        }

        // Get the location if it's the first call
        if (self.firstGeolocationCall) {
            self.firstGeolocationCall = false;

            // Get the current location
            navigator.geolocation.getCurrentPosition(
                // Getting location succeeded
                location => {
                    // See if the location is valid
                    if (location.coords.latitude && location.coords.longitude) {
                        self.currentLocation = {
                            latitude: location.coords.latitude,
                            longitude: location.coords.longitude,
                        };
                    } else {
                        self.currentLocation = null;
                    }

                    self.loading = false;
                    self.locationIsSet = true;
                    self.setLocationInSession();
                    defer.resolve(self.currentLocation);
                },
                // Error when getting location
                error => {
                    defer.reject(error);
                }
            );
        }
        return defer;
    };

    self.loadingLocation = () => {
        return self.loading;
    };

    /**
     * Set a visitor location in the server session
     * @return {void}
     */
    self.setLocationInSession = () => {
        let latitude = '';
        if(typeof self.currentLocation.latitude !== 'undefined') {
            latitude = self.currentLocation.latitude;
        }
        localStorage.setItem('latitude', latitude);

        let longitude = '';
        if(typeof self.currentLocation.longitude !== 'undefined') {
            longitude = self.currentLocation.longitude;
        }
        localStorage.setItem('longitude', longitude);

        MrMovie.pageFilter.setHeader('latitude', latitude);
        MrMovie.pageFilter.setHeader('longitude', longitude);

        MrMovie.session.set({
            latitude: latitude,
            longitude: longitude
        }, 'geolocation');
        VueEvents.$emit('location_set_in_session', self.currentLocation);
    };

    /**
     * Set a visitor location in the server session
     * @return null|object
     */
    self.getLocationFromSession = () => {
        let result = null;
        if(localStorage.getItem('latitude') && localStorage.getItem('longitude')) {
            result = {
                'latitude': localStorage.getItem('latitude'),
                'longitude': localStorage.getItem('longitude'),
            };
        }
        return result;

    };
}



// WEBPACK FOOTER //
// ./resources/js/MrMovie/Geolocation.js